/** Client page size for Regulatory Watch tables (My references flat view, My updates, Audit). */
export const REGULATORY_WATCH_TABLE_PAGE_SIZE = 50;

/** Unified bottom bar — My updates by status (`ReviewCardList`) and table pagination footers. */
export const REGULATORY_WATCH_BOTTOM_BAR_HEIGHT_PX = 45;
